import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  type ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';

@Component({
  selector: 'app-install-information-panel',
  imports: [],
  templateUrl: './install-information-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallInformationPanelComponent {
  protected readonly data: { text: string } = inject(MAT_BOTTOM_SHEET_DATA);

  protected readonly viewerElement = viewChild<ElementRef<HTMLDivElement>>('viewer');

  constructor() {
    const destroyRef = inject(DestroyRef);
    const effectRef = effect(() => {
      const viewerElement = this.viewerElement();

      if (viewerElement !== undefined && this.data?.text !== null) {
        const viewer = new Viewer({
          el: viewerElement.nativeElement,
          initialValue: this.data.text,
          theme: 'dark',
        });
        destroyRef.onDestroy(() => viewer.destroy());
        effectRef.destroy();
      }
    });
  }
}
